import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslatePipe } from '@spartacus/core';

@Component({
    selector: 'kn-br-confirm-dialog',
    templateUrl: './kn-br-confirm-dialog.component.html',
    styleUrls: ['./kn-br-confirm-dialog.component.scss'],
    imports: [TranslatePipe]
})
export class KnBrConfirmDialogComponent implements OnInit {
  @Input() title: string;
  @Input() message: string;
  @Input() btnOkText: string;
  @Input() btnCancelText: string;
  constructor(private activeModal: NgbActiveModal) {}
  ngOnInit() {}
  public decline() {
    this.activeModal.close(false);
  }
  public accept() {
    this.activeModal.close(true);
  }
  public dismiss() {
    this.activeModal.dismiss();
  }
}
